import React, { useState, useRef, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
export const FormularioNombre = (props) => {
const { errores ,usuario, setUsuarios  } = props;
   const handleChange = e => {
        const { name, value } = e.target;
        let valorPropiedad = value;
        
        setUsuarios(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: valorPropiedad
        }));
    };
    return (
        <div>
         <div className="grid">
         <div className="card">
         <div className="p-fluid formgrid grid">
         <div className="field col-12 md:col-6">
                                <label htmlFor="rfc">Nombre</label>
                                <InputText id="nombre" type="text" name="nombre"
                                    value={usuario.nombre || ""}  onChange={handleChange} className={errores.nombre ? "p-invalid" : ""} />
                                {errores.nombre ? <div><Message severity="error" text={errores.nombre} /></div> : null}
                            </div>

            </div>
            </div>


         </div>
        </div>
    )
}